import {useQuery} from '@apollo/client';
import {ezManagePermissionsQuery} from './WithEzManagePermissions';
import {ezManagePermissionsQuery as DataType} from '../__generated__/ezManagePermissionsQuery';

const useEzManagePermissions = () => useQuery<DataType>(ezManagePermissionsQuery);

export default useEzManagePermissions;
